<div class="kanban-content">
  @if ($swimlanes().length) {
    <div class="swimlane-header">
      @if ($showSwimlaneColumn()) {
        <div class="swimlane-column" [title]="$swimlaneColumnHeader()">
          <div class="swimlane-column-header flex-row flex-v-center">
            <div class="column-title flex-fill column-name">
              {{ $swimlaneColumnHeader() }}
            </div>
            <div class="column-count flex-auto">
              <div class="tag">{{ $swimlanes().length }}</div>
            </div>
          </div>
        </div>
      }

      @for (column of $columns(); track column.key) {
        <div class="column" [class.empty]="!column.hasItems" [class.collapsed]="!!column.collapsed" [title]="column.name">
          @if ($columnTemplate(); as columnTemplate) {
            <ng-container [ngTemplateOutlet]="columnTemplate" [ngTemplateOutletContext]="{ $implicit: column, count: columnItemCount(column.key) }" />
          } @else {
            <div class="swimlane-column-header flex-row flex-v-center" [title]="column.name">
              <div class="column-title collapse-area flex-fill">
                {{ column.name }}
              </div>
              <div class="column-count collapse-area flex-auto">
                <div class="tag">{{ columnItemCount(column.key) }}</div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  }

  <div class="swimlanes">
    @for (lane of $swimlanes(); track lane.key ?? lane.name) {
      <kanban-swimlane [swimlane]="lane" [showHeader]="$showHeader() && $swimlanes().length > 1" [host]="host" />
    }
  </div>
</div>